import { createFileRoute } from '@tanstack/react-router'
import { ResetCredentials } from "@/components/credentials-reset";

export const Route = createFileRoute('/credential-reset')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ResetCredentials/>
}
